import request from '@/config/axios'

export type PartnerBenefitItem = {
  title: string
  desc?: string
}

export type PartnerTierVO = {
  id?: number
  code: string
  name: string
  badge?: string
  priceYuan: number
  discount?: number
  theme: string
  rank: number
  highlightLabels?: string[]
  benefits?: PartnerBenefitItem[]
  sortOrder?: number
  status?: number
  createTime?: string
  updateTime?: string
}

export const getPartnerTierList = () =>
  request.get<PartnerTierVO[]>({ url: '/bosscircle/partner-tier/list' })

export const savePartnerTier = (data: PartnerTierVO) =>
  request.post({ url: '/bosscircle/partner-tier/save', data })

export const deletePartnerTier = (id: number) =>
  request.delete({ url: '/bosscircle/partner-tier/delete', params: { id } })
